import { render, staticRenderFns } from "./CreateTicketByTech.vue?vue&type=template&id=0a4e0f02&scoped=true&"
import script from "./CreateTicketByTech.vue?vue&type=script&lang=js&"
export * from "./CreateTicketByTech.vue?vue&type=script&lang=js&"
import style0 from "./CreateTicketByTech.vue?vue&type=style&index=0&id=0a4e0f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e0f02",
  null
  
)

export default component.exports